import { VISITOR_COOKIE_NAME, VISITOR_ID_ORIGIN_HASH_COOKIE_NAME } from './constants';
import Identifier from './identifiers/identifiers';
import { CookieUtils } from './types/cookies_utils';

class Visitor {
  constructor(
    private readonly identifier: Identifier,
    private readonly cookieUtils: CookieUtils,
  ) {}

  getVisitorId() {
    // This does nothing if valid vi cookie has been set already
    this.identifier.authorizeIdentifier(VISITOR_COOKIE_NAME);

    return this.cookieUtils.getCookie(VISITOR_COOKIE_NAME);
  }

  getVisitorIdOriginHash() {
    const cookie = this.cookieUtils.getCookie(VISITOR_ID_ORIGIN_HASH_COOKIE_NAME);

    return cookie && decodeURIComponent(cookie);
  }

  checkResetVisitorId(userId: string) {
    return this.identifier.checkResetIdentifier(
      userId,
      VISITOR_ID_ORIGIN_HASH_COOKIE_NAME,
      VISITOR_COOKIE_NAME,
    );
  }
}

export default Visitor;
